// extracted by mini-css-extract-plugin
export var avatarContainer = "_cq-0";
export var avatarTypingWave = "_cq-i";
export var gray = "_cq-f";
export var green = "_cq-c";
export var icon = "_cq-9";
export var image = "_cq-1";
export var lg = "_cq-6";
export var md = "_cq-5";
export var presenceDot = "_cq-b";
export var red = "_cq-d";
export var sm = "_cq-4";
export var status = "_cq-a";
export var typingDot = "_cq-h";
export var typingPill = "_cq-g";
export var xl = "_cq-7";
export var xs = "_cq-3";
export var xxl = "_cq-8";
export var xxs = "_cq-2";
export var yellow = "_cq-e";